var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_111_1241)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 55C31.7155 55 25 48.2845 25 40C25 31.7155 31.7155 25 40 25C48.2845 25 55 31.7155 55 40C55 48.2845 48.2845 55 40 55ZM40 53.2C43.5009 53.2 46.8583 51.8093 49.3338 49.3338C51.8093 46.8583 53.2 43.5009 53.2 40C53.2 36.4991 51.8093 33.1417 49.3338 30.6662C46.8583 28.1907 43.5009 26.8 40 26.8C36.4991 26.8 33.1417 28.1907 30.6662 30.6662C28.1907 33.1417 26.8 36.4991 26.8 40C26.8 43.5009 28.1907 46.8583 30.6662 49.3338C33.1417 51.8093 36.4991 53.2 40 53.2ZM39.01 31.6465H40.99L40.8565 42.2365H39.145L39.013 31.6465H39.01ZM40 47.6095C39.835 47.6115 39.6712 47.5805 39.5183 47.5183C39.3654 47.456 39.2266 47.3638 39.1099 47.2471C38.9932 47.1304 38.901 46.9916 38.8387 46.8387C38.7765 46.6858 38.7455 46.522 38.7475 46.357C38.7444 46.1917 38.7748 46.0274 38.8366 45.8741C38.8985 45.7208 38.9906 45.5815 39.1076 45.4646C39.2245 45.3476 39.3638 45.2555 39.5171 45.1936C39.6704 45.1318 39.8347 45.1014 40 45.1045C40.714 45.1045 41.2525 45.6445 41.2525 46.357C41.2556 46.5223 41.2252 46.6866 41.1634 46.8399C41.1015 46.9932 41.0094 47.1325 40.8925 47.2495C40.7755 47.3664 40.6362 47.4585 40.4829 47.5204C40.3296 47.5822 40.1653 47.6126 40 47.6095Z",
    fill: "#FD1010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_111_1241",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_111_1241"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.882353 0 0 0 0 0.882353 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_1241"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_1241",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalAlert);
export default __webpack_public_path__ + "static/media/modal-alert.9b1f8bfb0ebad5dd5e4b8977db37354d.svg";
export { ForwardRef as ReactComponent };